import { useState, useRef, useEffect, useCallback } from 'react';

function useStateWithDeps(initialState) {
    const [, rerender] = useState({});
    const unmounted = useRef(false);
    useEffect(() => {
        return () => {
            unmounted.current = true;
        };
    }, []);
    const stateRef = useRef(initialState);
    // this is initialized once
    const stateDependenciesRef = useRef(Object.keys(stateRef.current).reduce((prev, curr) => ({ ...prev, [curr]: false }), {}));
    const setState = useCallback((payload) => {
        let shouldRerender = false;
        const currentState = stateRef.current;
        for (const k in payload) {
            // If the property has changed, update the state
            if (currentState[k] !== payload[k]) {
                currentState[k] = payload[k];
                // If the property is accessed, a rerender should be triggered.
                if (stateDependenciesRef.current[k]) {
                    shouldRerender = true;
                }
            }
        }
        if (shouldRerender && !unmounted.current) {
            rerender({});
        }
    }, [rerender]);
    return [stateRef, setState, stateDependenciesRef.current];
}

export { useStateWithDeps };
//# sourceMappingURL=useStateWithDeps.js.map
